import { API_BASE, BACKEND_URL } from "./apiBase";

const BASE = API_BASE;
const KEY = "hrd_admin_token";

export const getToken = () => localStorage.getItem(KEY) || "";
export const setToken = (t) => localStorage.setItem(KEY, t);
export const clearToken = () => localStorage.removeItem(KEY);

async function handle(res) {
  if (res.status === 204) return null;
  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    data = null;
  }
  if (!res.ok) {
    const msg = (data && (data.detail || data.message)) || "Beklenmeyen bir hata olu\u015ftu";
    const err = new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
    err.status = res.status;
    throw err;
  }
  if (data === null) {
    throw new Error(
      "Sunucudan ge\u00e7ersiz yan\u0131t al\u0131nd\u0131. Backend adresi (REACT_APP_BACKEND_URL) yap\u0131land\u0131rmas\u0131n\u0131 kontrol edin."
    );
  }
  return data;
}

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getToken()}`,
});

// backend-served uploads come back as /api/files/... — make them absolute
export const assetUrl = (u) =>
  !u ? "" : u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u;

export const api = {
  login: (username, password) =>
    fetch(`${BASE}/admin/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    }).then(handle),

  me: () => fetch(`${BASE}/admin/me`, { headers: authHeaders() }).then(handle),

  projects: () => fetch(`${BASE}/projects`).then(handle),
  project: (slug) => fetch(`${BASE}/projects/${slug}`).then(handle),
  categories: () => fetch(`${BASE}/projects/categories`).then(handle),

  createProject: (body) =>
    fetch(`${BASE}/admin/projects`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(body),
    }).then(handle),

  updateProject: (id, body) =>
    fetch(`${BASE}/admin/projects/${id}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(body),
    }).then(handle),

  deleteProject: (id) =>
    fetch(`${BASE}/admin/projects/${id}`, {
      method: "DELETE",
      headers: authHeaders(),
    }).then(handle),

  enquiries: () => fetch(`${BASE}/admin/enquiries`, { headers: authHeaders() }).then(handle),

  unreadCount: () => fetch(`${BASE}/admin/enquiries/unread-count`, { headers: authHeaders() }).then(handle),

  setEnquiryRead: (id, read) =>
    fetch(`${BASE}/admin/enquiries/${id}/read`, {
      method: "PATCH",
      headers: authHeaders(),
      body: JSON.stringify({ read }),
    }).then(handle),

  deleteEnquiry: (id) =>
    fetch(`${BASE}/admin/enquiries/${id}`, { method: "DELETE", headers: authHeaders() }).then(handle),

  analytics: (days = 7) =>
    fetch(`${BASE}/admin/analytics?days=${days}`, { headers: authHeaders() }).then(handle),

  collections: () => fetch(`${BASE}/collections`).then(handle),
  content: () => fetch(`${BASE}/content`).then(handle),
  updateContent: (key, data) =>
    fetch(`${BASE}/admin/content/${key}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({ data }),
    }).then(handle),
  adminCollections: () => fetch(`${BASE}/admin/collections`, { headers: authHeaders() }).then(handle),

  createCollection: (body) =>
    fetch(`${BASE}/admin/collections`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(body),
    }).then(handle),

  updateCollection: (id, body) =>
    fetch(`${BASE}/admin/collections/${id}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(body),
    }).then(handle),

  setCollectionPdf: (id, pdf_url, pdf_name = "") =>
    fetch(`${BASE}/admin/collections/${id}/pdf`, {
      method: "PATCH",
      headers: authHeaders(),
      body: JSON.stringify({ pdf_url, pdf_name }),
    }).then(handle),

  deleteCollection: (id) =>
    fetch(`${BASE}/admin/collections/${id}`, {
      method: "DELETE",
      headers: authHeaders(),
    }).then(handle),

  upload: (fileList) => {
    const fd = new FormData();
    Array.from(fileList).forEach((f) => fd.append("files", f));
    return fetch(`${BASE}/admin/upload`, {
      method: "POST",
      headers: { Authorization: `Bearer ${getToken()}` },
      body: fd,
    }).then(handle);
  },

  sendEnquiry: (body) =>
    fetch(`${BASE}/enquiries`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(handle),
};
